import { WidgetRowFactory } from '../base/row/WidgetRowFactory'
import { WidgetType } from '../base/widget/WidgetTypes'
import { WidgetContainer } from './WidgetContainerInterface'

export const WidgetWidgetContainer: WidgetContainer = {
  type: WidgetType.widgetContainer,
  isFrameless: true,
  title: 'Container',
  defaultSize: 16,
  minSize: 6,
  maxSize: 0,
  rows: [WidgetRowFactory.createEmpty()],
  icon: 'PackageVariant',
  dashboardSettings: {}
}

export default WidgetWidgetContainer
